import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import {
    setIsReadyForDownload,
    setShowPurchaseTypeDrawer
} from "core/AssetDownload/Context/actions";

// styles
import { GetAssetButtonStyled } from "./styles";

// auth
import { useAuth } from "frontend/hooks/useAuth";

const GetAssetButton = () => {
    const { state, dispatch } = useContext(AssetDownloadContext);

    const {
        purchaseType,
        asset,
        showPurchaseTypeDrawer,
        assetDownloadConfig
    } = state;

    const { purchaseTypeKeys, getThisAssetButtonText } = assetDownloadConfig;

    const { confirmAuth, isLoggedIn } = useAuth();

    // We do not want the Get Button to work when logged in and selecting purchase type in modal.
    const isDisabled = showPurchaseTypeDrawer && isLoggedIn;

    const handleConfirmAuthSuccess = () => {
        // if public domain
        if (purchaseType.key === purchaseTypeKeys.public) {
            dispatch(setIsReadyForDownload(true));
        } else {
            dispatch(setShowPurchaseTypeDrawer(true));
        }
    };

    return (
        <GetAssetButtonStyled
            styleType="cta"
            darkMode
            width="100%"
            isDisabled={isDisabled}
            onClick={() => {
                confirmAuth({
                    onSuccess: handleConfirmAuthSuccess
                });
            }}
        >
            {getThisAssetButtonText}
        </GetAssetButtonStyled>
    );
};

export default GetAssetButton;
